import { MuiButtonBase } from '@/features/shared/material-ui';
import { getChipCategoryLabel, getPageUrl, mapLinkToProps } from '@/utils/helpers';
import { useMemo } from 'react';

export const useCardCategories = (
  page: any,
  labels: any,
  categoryUrl: any,
  category: any,
  contentCategory: any,
  categoryType: any,
) => {
  return useMemo(() => {
    const categoryProps = (arg: string) => {
      if (categoryUrl[arg]) {
        const href = page && getPageUrl({ url: categoryUrl[arg] || '', page });
        return { ...mapLinkToProps({ href }), 'aria-label': arg };
      }
      return { component: MuiButtonBase };
    };

    const isCategory = !!(category && category?.length);
    let categoryWrapped = (isCategory ? category : [contentCategory]) || [];

    if (!Array.isArray(categoryWrapped)) {
      categoryWrapped = [categoryWrapped];
    }

    const clickType = (isCategory ? categoryType : 'tax_content_category') || '';
    const chipLabel = getChipCategoryLabel({ isCategory, labels });

    return {
      categoryProps,
      categoryWrapped,
      clickType,
      chipLabel,
    };
  }, [page, labels, categoryUrl, category, contentCategory, categoryType]);
};
